// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"token-line_wrapper__2BPzq","text":"token-line_text__2qLXR","tooltipIcon":"token-line_tooltipIcon__2rUPF","tooltipText":"token-line_tooltipText__1xShD"};